module.exports = __webpack_public_path__ + "img/ron_n_2.189cbba1.png";